/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Nofilterresults3Inputs */

const en_coinvestments_tracking_nofilterresults3 = /** @type {(inputs: Coinvestments_Tracking_Nofilterresults3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organisations found`)
};

/**
* | output |
* | --- |
* | "No organisations found" |
*
* @param {Coinvestments_Tracking_Nofilterresults3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_nofilterresults3 = /** @type {((inputs?: Coinvestments_Tracking_Nofilterresults3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Nofilterresults3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_nofilterresults3(inputs)
});
export { coinvestments_tracking_nofilterresults3 as "coInvestments_tracking_noFilterResults" }